// Post-processing parameter types for export pipeline

export interface PostProcessParams {
  /** Global contrast boost 0..0.2 (0 = off) */
  contrast: number
  /** Exposure adjustment in EV 0..0.3 (0 = off) */
  exposure: number
  /** Saturation boost 0..0.15 (0 = off) */
  saturation: number
  /** Unsharp-mask sharpening intensity 0..2 (0 = off) */
  sharpening: number
  /** Micro-contrast / clarity 0..1 (0 = off) */
  clarity: number
  /** Vignette darkness 0..0.5 (0 = off) */
  vignetteStrength: number
  /** Vignette inner-radius ratio 0..1 (larger = more subtle) */
  vignetteRadius: number
}

export const DEFAULT_POST_PROCESS_PARAMS: PostProcessParams = {
  contrast: 0.0,
  exposure: 0.01,
  saturation: 0.015,
  sharpening: 0.2,
  clarity: 0.06,
  vignetteStrength: 0.06,
  vignetteRadius: 0.8,
}
